"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledCheckboxCell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const design_system_1 = require("@hashintel/design-system");
const material_1 = require("@mui/material");
const entity_type_table_1 = require("../shared/entity-type-table");
const DisabledCheckboxCell = ({ title, checked, width, sx, }) => {
    return ((0, jsx_runtime_1.jsx)(entity_type_table_1.EntityTypeTableCenteredCell, { width: width, children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: title, placement: "top", disableInteractive: true, classes: { popper: design_system_1.fluidFontClassName }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: [
                    {
                        boxSizing: "content-box",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    },
                    ...(Array.isArray(sx) ? sx : [sx]),
                ], children: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { disabled: true, checked: checked, sx: [
                        {
                            color: ({ palette }) => `${palette.gray[40]} !important`,
                            [`.${material_1.svgIconClasses.root}`]: {
                                color: "inherit",
                            },
                            [`&.${material_1.checkboxClasses.checked}.${material_1.checkboxClasses.disabled}`]: {
                                color: ({ palette }) => `${palette.blue[30]} !important`,
                            },
                        },
                    ] }) }) }) }));
};
exports.DisabledCheckboxCell = DisabledCheckboxCell;
